module.exports = __webpack_public_path__ + "static/assets/5498c02a90fc8a8f6225a6eb93e9c81f.jpg";